import axios from 'axios'
import moment from 'moment'
import api from '../../services/api'


export function getFiltro(id, data_ini, data_fin) {
    console.log(id)
    console.log(data_ini)
    console.log(data_fin)
    return {
        type: 'deals',
        name: `relatoriosms${id}`,
        conditions: {
            glue: "and",
            //Negócio aberto
            conditions: [
                {
                    "glue": "and",
                    "conditions": [
                        {
                            "object": "deal",
                            "field_id": "12461",
                            "operator": "=",
                            "value": "open",
                            "extra_value": null
                        },
                        {
                            "object": "deal",
                            "field_id": "12462",
                            "operator": ">=",
                            "value": moment(data_ini).format('YYYY-MM-DD'),
                            "extra_value": null
                        },
                        {
                            "object": "deal",
                            "field_id": "12462",
                            "operator": "<=",
                            "value": moment(data_fin).format('YYYY-MM-DD'),
                            "extra_value": null
                        }
                    ]
                },
                {
                    "glue": "or",
                    "conditions": [
                        {
                            //telefone hot
                            "object": "person",
                            "field_id": "9081",
                            "operator": "IS NOT NULL",
                            "value": null,
                            "extra_value": null
                        },
                        {
                            //telefone hot
                            "object": "person",
                            "field_id": "9079",
                            "operator": "IS NOT NULL",
                            "value": null,
                            "extra_value": null
                        },
                        {
                            //whatsapp hot
                            "object": "person",
                            "field_id": "9080",
                            "operator": "IS NOT NULL",
                            "value": null,
                            "extra_value": null
                        }
                    ]
                }
            ]
        }
    }
}

const wpp_hot = '171de1827d25ed254cb11d379f1b1c7b330929c4'
const tel_hot_2 = 'ab5da3c69babda6f5c6fff9c583b6396481de504'
const tel_hot_1 = '92dfdd01aac099bc636572a05a337bbd826775dc'
const carteira = '45d771296989bde07beb7c2eb1f24ed7ca10dcf6'
const pasta = 'f9a0b58d523b64c5a881371570b3fdefeccdc0b8'
const BO = 'e2fa8861bb2c03cb6614ebb826cda8c9245eaa98'

export async function mountArrayToCSV(data, filtro) {
    let csv_array = []
    //console.log(data)
    const res_token_pipedrive = await api.get('/tokens/')
    const token = res_token_pipedrive.data.pipedrive
    await data.map(async function (value) {

        const res = await axios.get(`https://api.pipedrive.com/v1/persons/${value.person_id.value}?api_token=${token}`)
        const pessoa = res.data.data
        //console.log(pessoa)
        if (pessoa[wpp_hot] != null) {
            csv_array.push(`${value[pasta]},${pessoa[wpp_hot]},${value[BO]},${value[carteira]},${value.owner_name}`)
        }
        if (pessoa[tel_hot_1] != null) {
            csv_array.push(`${value[pasta]},${pessoa[tel_hot_1]},${value[BO]},${value[carteira]},${value.owner_name}`)
        }
        if (pessoa[tel_hot_2] != null) {
            csv_array.push(`${value[pasta]},${pessoa[tel_hot_2]},${value[BO]},${value[carteira]},${value.owner_name}`)
        }
    })
    //console.log(csv_array)
    return csv_array
}


// WEBPACK FOOTER //
// ./src/pages/Relatorios/modules.js